// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__20ShK","ranges":"BmiRanges_ranges__1iF_4"};